import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Alert, Snackbar } from '@mui/material';

/**
 * کامپوننت بررسی وضعیت احراز هویت
 * این کامپوننت وضعیت توکن را در localStorage بررسی می‌کند
 */
const AuthChecker: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const [error, setError] = useState<string | null>(null);
  
  const checkStatus = async () => {
    try {
      // اگر کاربر احراز هویت نشده است، نیازی به بررسی نیست
      if (!isAuthenticated) return;
      
      const token = localStorage.getItem('accessToken');
      if (!token) {
        console.warn('No access token found in localStorage');
        // ریدایرکت به صفحه لاگین
        logout();
        navigate('/login');
        return;
      }
      
      // فقط بررسی وجود توکن در localStorage کافی است
      console.log('Local token check successful');
    } catch (err) {
      console.error('Auth check failed:', err);
      
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('خطا در بررسی وضعیت ورود به سیستم');
      }
    }
  };
  
  useEffect(() => {
    // بررسی اولیه هنگام بارگذاری کامپوننت
    checkStatus();
    
    // بررسی دوره‌ای هر 5 دقیقه
    const interval = setInterval(() => {
      checkStatus();
    }, 5 * 60 * 1000);
    
    return () => {
      clearInterval(interval);
    };
  }, [isAuthenticated]);
  
  // هندلر بستن پیام خطا
  const handleCloseError = () => {
    setError(null);
  };
  
  // این کامپوننت فقط وضعیت را بررسی می‌کند و چیزی رندر نمی‌کند (به جز پیام خطا)
  return (
    <Snackbar
      open={!!error}
      autoHideDuration={6000}
      onClose={handleCloseError}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
        {error}
      </Alert>
    </Snackbar>
  );
};

export default AuthChecker; 